// Configuración principal de la aplicación
export const config = {
  // URL de la API
  apiUrl: import.meta.env.VITE_API_URL || 'https://dev.api.clientesinoelec.com',

  // Configuración de la aplicación
  app: {
    name: 'Inoelec Admin',
    version: '1.0.0',
    description: 'Panel de administración para Inoelec',
  },

  // Configuración de desarrollo
  isDevelopment: import.meta.env.DEV,
  isProduction: import.meta.env.PROD,

  // Configuración de paginación
  pagination: {
    defaultPerPage: 25,
    perPageOptions: [10, 25, 50, 100],
  },

  // Configuración de idioma
  locale: 'es',

  // Configuración de autenticación
  auth: {
    tokenKey: 'accessToken', // ✅ Unificado con authService
    refreshTokenKey: 'refreshToken', // ✅ Unificado con authService
    loginPath: '/login',
    homePath: '/dashboard',
  },
} as const;
